module.exports = __webpack_public_path__ + "img/num-3.7ae39ca3.svg";